var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"list","tag":"p"}},[_c('p',{staticClass:"badge-text"},[_c('a-badge',{attrs:{"status":_vm.preparePingStatus(_vm.ping)}}),_c('strong',[_vm._v(_vm._s(_vm.name)+": ")]),_vm._v(_vm._s(_vm.preparePingValue(_vm.ping))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }